import * as ActionTypes from '../constants/ActionTypes';

const INITIAL_STATE = {};

const initForm = (state, { form, field, fieldValue, validations = [] }) => {
	const formData = state[form] || {};
	let fields = formData.fields || [];
	const values = formData.values || {};
	const errors = formData.errors || {};
	if (!fields.includes(field)) fields = [...fields, field];
	const existingValidations = formData?.validations || {};

	return {
		...state,
		[form]: {
			fields,
			formError: '',
			values: { ...values, [field]: fieldValue === undefined ? '' : fieldValue },
			errors: { ...errors, [field]: [] },
			validations: { ...existingValidations, [field]: validations },
		},
	};
};

const initMediaForm = (state, { provider, url }) => {
	const providers = state?.socialLinks || {};
	return {
		...state,
		socialLinks: {
			...providers,
			[provider]: {
				provider: provider === undefined ? '' : provider,
				url: url === undefined ? '' : url,
			},
		},
	};
};

const addMediaForm = (state, { provider, url }) => {
	const providers = state?.socialLinks || {};
	return {
		...state,
		socialLinks: {
			...providers,
			[provider]: {
				provider: provider === undefined ? '' : provider,
				url: url === undefined ? '' : url,
			},
		},
	};
};

const addFormData = (state, { form, data }) => {
	const formData = state[form];
	const { values, errors } = formData;

	return {
		...state,
		[form]: {
			...formData,
			values: { ...values, ...data.values },
			errors: { ...errors, ...data.errors },
			formUpdated: true,
		},
	};
};

const resetForm = (state, payload: any) => ({
	...state,
	[payload]: { fields: [], values: {}, errors: {} },
});

export default (state = INITIAL_STATE, { type, payload }) => {
	switch (type) {
		case ActionTypes.INIT_FORM:
			return initForm(state, payload);
		case ActionTypes.ADD_FORM_DATA:
			return addFormData(state, payload);
		case ActionTypes.INIT_SOCIAL_FORM:
			return initMediaForm(state, payload);
		case ActionTypes.ADD_SOCIAL_FORM_DATA:
			return addMediaForm(state, payload);
		case ActionTypes.RESET_FORM_DATA:
			return resetForm(state, payload);
		default:
			return state;
	}
};
